// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/codebuild/output/src052985490/src/canevsroadtrip/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/codebuild/output/src052985490/src/canevsroadtrip/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

